if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super()
      this.removeListener = false
      this.mouseOverListener = false
      this.mainSlider = this.querySelector('.splide.slider-component--product')

      this.splideMain = new Splide(this.mainSlider, {
        direction: 'ltr',
        rewind: true,
        pagination: true,
        arrows: true,
        autoHeight: true,
      })

      this.splideMain.mount()

      this.observeWrapper()

      if (window.matchMedia('(min-width: 990px)').matches) {
        this.mainSlider.addEventListener('mouseover', this.onMouseOver)
      }

      addEventListener('resize', () => {
        if (
          window.matchMedia('(min-width: 990px)').matches &&
          !this.removeListener
        ) {
          this.mainSlider.addEventListener('mouseover', this.onMouseOver)
        }
        if (
          window.matchMedia('(max-width: 989px)').matches &&
          this.removeListener
        ) {
          this.removeListener?.()
          this.removeListener = false
          this.mainSlider.removeEventListener('mouseover', this.onMouseOver)
        }
      })
    }

    observeWrapper() {
      new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            e.target.parentNode.classList.toggle('-scrolled', !e.isIntersecting)
          })
        },
        { rootMargin: '-100% 0px 0px 0px', threshold: 0 }
      ).observe(this)
    }
  }

  customElements.define('product-slider', ProductSlider)
}

if (!customElements.get('slider-component')) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super()

      if (this.querySelector('.splide')) {
        const splide = new Splide(this, {
          rewind: true,
          pagination: true,
          arrows: false,
          height: '100vh',
          direction: 'ttb',
          wheel: true,
          mediaQuery: 'max',
          breakpoints: {
            990: {
              wheel: false,
              direction: 'ltr',
            },
          },
        }).mount()
      }
    }
  }

  customElements.define('slider-component', SliderComponent)
}

if (!customElements.get('product-card-slider')) {
  const DURATION = 300
  const EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  class ProductCardSlider extends HTMLElement {
    constructor() {
      super()
      this.mainSlider = this.querySelector('.swiper')
      this.init()
    }

    init() {
      const id = this.dataset.id
      this.swiperMain = new Swiper(this.mainSlider, {
        slidesPerView: 'auto',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        lazy: {
          loadPrevNext: true,
        },
        navigation: {
          prevEl: `product-card-slider[data-id="${id}"] .swiper-button-prev`,
          nextEl: `product-card-slider[data-id="${id}"] .swiper-button-next`,
        },
        init: false,
      })

      this.speed = this.swiperMain.params.speed

      this.fadeInSlide = (el, callback, startingOpacity) => {
        el.animate(
          [
            { opacity: startingOpacity || 0.4 },
            {
              opacity: 1,
            },
          ],
          {
            duration: DURATION,
            easing: EASING,
            iterations: 1,
            fill: 'forwards',
          }
        ).onfinish = () => {
          el.classList.remove('shift')
          if (callback) {
            callback()
          }
        }
      }

      this.fadeOutSlide = (el) => {
        el.animate(
          [
            { opacity: 1 },
            {
              opacity: 0.4,
            },
          ],
          {
            duration: DURATION,
            easing: EASING,
            iterations: 1,
          }
        )
      }

      // Handles hover effect where we move to the second slide on hover
      // There is a quick fade effect instead of the carousel L/R slide
      // We are manually shifting to the second slide, fading it in, and then advancing the carousel -- creates a cross-fade effect
      this.handleMouseEnter = (slides) => {
        const realIndex = this.swiperMain.realIndex

        if (realIndex !== 0) {
          return
        }

        const slideToHide = slides[realIndex]
        const slideToShow = slides[realIndex + 1]

        if (!slideToHide || !slideToShow) return

        if (slideToHide) {
          this.fadeOutSlide(slideToHide)
        }

        slideToShow.classList.add('shift')
        const fadeInCallback = () =>
          this.swiperMain.slideToLoop(realIndex + 1, 0) // second param here sets 0ms speed for instant transition
        this.fadeInSlide(slideToShow, fadeInCallback)
      }

      // used for the hover effect; switch back to first slide, on mouseLeave, if we've moved to the second slide via hover
      this.handleMouseLeave = (slides) => {
        const realIndex = this.swiperMain.realIndex

      
        if (realIndex > 1) {
          return
        }

        const slideToShow = slides[0] 
        const slideToHide = slides[1]
        const shifted = slideToHide?.matches('.shift')

        if (!slideToShow || !slideToHide) {
          return
        }

        // Shifted means that animation has NOT finished yet, so we'll just cancel and manually remove class
        if (shifted && realIndex === 0) {
          const animations = [
            ...slideToShow.getAnimations(),
            ...slideToHide.getAnimations(),
          ]
          animations.forEach((animation) => animation.cancel())
          slideToHide.classList.remove('shift')
          return
        }

        // No crossfade effect on mouseout, so .6 opacity makes it less of a flash
        if (realIndex != 0) {
          this.fadeInSlide(slideToShow, null, 0.6)
        } 

        // including this in the fadeInSlide callback was causing a flicker, but when used here the transition is smooth
        this.swiperMain.slideToLoop(0, 0) // second param here sets 0ms speed for instant transition
      }

      this.swiperMain.on('init', () => {
        const slides = this.swiperMain.slides

        if (!slides || slides.length < 2) {
          return
        }

        this.addEventListener('mouseenter', () => this.handleMouseEnter(slides))
        this.addEventListener('mouseleave', () => this.handleMouseLeave(slides))
      })

      // Using setTimeout to prevent a "long task" while all of these swipers init
      setTimeout(() => {
        this.swiperMain.init();
      })
    }
  }

  customElements.define('product-card-slider', ProductCardSlider)
}
